import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1c55d74c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=1c55d74c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55d74c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c55d74c')) {
      api.createRecord('1c55d74c', component.options)
    } else {
      api.reload('1c55d74c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1c55d74c&scoped=true", function () {
      api.rerender('1c55d74c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/spellGroup/goodsList/detail.vue"
export default component.exports